import { Icon } from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./Dates.module.scss";
import clsx from "clsx";
import CruiseDepartureArrivalDates from "components/cruises/CruiseDepartureArrivalDates";
import CruiseDuration from "components/cruises/CruiseDuration";

type Props = {
  departureDate: Date | undefined;
  arrivalDate: Date | undefined;
  durationDays: number | undefined;
  separator?: "icon" | "bullet";
  className?: string;
};

const Dates: React.FC<Props> = ({
  departureDate,
  arrivalDate,
  durationDays: days,
  separator = "icon",
  className
}) => {
  return (
    <div
      role="contentinfo"
      className={clsx(
        styles.container,
        {
          [styles.containerInline]: separator == "bullet"
        },
        className
      )}
    >
      <div>
        <CruiseDepartureArrivalDates
          departureDate={departureDate}
          arrivalDate={arrivalDate}
        />
      </div>
      <div className={styles.duration}>
        {separator == "icon" && (
          <Icon name="clock" size="1x" padding="inline" ariaHidden />
        )}
        <CruiseDuration days={days} withSeparator />
      </div>
    </div>
  );
};

export default Dates;
